import { useEffect } from 'react';

interface Props {
  src: string;
  alt: string;
  onClose: () => void;
}

export default function ImageLightbox({ src, alt, onClose }: Props) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-foreground-950/90 p-4 anim-fade-in">
      <button
        type="button"
        aria-label="关闭大图"
        onClick={onClose}
        className="absolute inset-0 cursor-pointer"
      />
      <div className="relative z-10 max-h-[88vh] w-auto max-w-[min(92vw,620px)]">
        <img
          src={src}
          alt={alt}
          title={alt}
          className="max-h-[88vh] w-full rounded-lg object-contain"
        />
        <p className="mt-3 text-center text-xs text-background-200">{alt}</p>
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="关闭大图"
        className="absolute right-4 top-4 z-20 flex h-10 w-10 items-center justify-center rounded-full bg-background-50/15 text-background-50 backdrop-blur transition-colors hover:bg-background-50/25 cursor-pointer"
      >
        <i className="ri-close-line text-xl w-5 h-5 flex items-center justify-center" />
      </button>
    </div>
  );
}